module.exports = __webpack_public_path__ + "img/名校直通车图标橙色.5270cde7.png";